import './bootstrap.js'
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import store from './store.js';
import routes from './routes';
import companyApi from './api/company-api';
import axios from './api/helpdesk-axios';
import "./registerServiceWorker";
import Sidebar from './components/Sidebar.vue'
import Footer from './components/Footer.vue'
require('dayjs/locale/pl')
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pl';
import dayjs from "dayjs"
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import ThemeColor from './theme.js'
// import Lang from 'vue-lang'
import VueMask from 'v-mask'

import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)



Vue.use(VueMask);


import {
    Tooltip
} from "bootstrap";
window.onload = function() {
    ThemeColor.init();
}
var locales = {
    "en": require("./locale/en.json"),
    "pl": require("./locale/pl.json")
}
// Vue.use(Lang, {
//     lang: 'en',
//     locales: locales
// })
Vue.directive('tooltip', {
    // When the bound element is inserted into the DOM...
    inserted: function(el, bind) {
        new Tooltip(el, {
            trigger: 'hover',
            boundary: document.body
        })
    },
    update: function(el, bind) {
        setTimeout(function() {
            if(el.title){ 
                el.setAttribute('data-bs-original-title', el.title);
            }
            //console.log(el);
            Tooltip.getInstance(el).update();
        }, 250);
    }
})
dayjs.extend(customParseFormat)
Vue.use(Toast);
Vue.use(Vuex)
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes
});
router.afterEach(to => document.title = (to.meta.title ? to.meta.title : 'Helpdesk Magico'));
const BASE_URL = process.env.MIX_APP_URL;
const API_URL = process.env.MIX_API_URL;
const app = new Vue({
    router,
    store,
    el: "#app",
    name: "VueApp",
    components: {
        Sidebar,
        'app-footer': Footer
    },
    watch:{},
    data: function() {
        return {
            isLogin: false,
            oauth_code: '',
            oauth_state: '',
            refresh_time: 1200000,
        }
    },
    computed: {
        isAdmin: function() {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        }
    },
    created: function() {
        this.$store.dispatch('auth/loadFromStorage'); //ładownie localstorage do Vuex
        // alert(this.$store.state.auth.access_expires_in)
        if (this.$store.state.auth.access_token) {
            this.getCompanyMe();
        } else {
            let params = new URLSearchParams(document.location.search.substring(1));
            this.oauth_code = params.get('code')
            this.oauth_state = params.get('state')
            if (this.oauth_code) {
                this.getToken();
            } else {
                if (this.$store.state.auth.refresh_token) {
                    // this.refreshToken();
                }
                this.authorize();
            }
        }
        let vm = this;
    },
    mounted: function() {
        console.log('app_mounted');
        console.log(this.$lang);
    },
    methods: {
        getCompanyMe: function() {
            let vm = this;
            companyApi.getMe().then(e => {
                console.log('get,', e.data)
                //vm.$store.commit('app/setRole', e.data.data.role)
                //this.isLogin = true;
            });
            axios.get('api/v1/config').then(response => {
                console.log('ge2,', response.data)
                vm.$store.commit('app/setRole', response.data.user.role)
                vm.$store.commit('app/setOptions', response.data.options)
                // vm.$setLang('pl')
                vm.isLogin = true;
            });
        },
        logout() {
            this.$store.dispatch('auth/resetToken');
            this.isLogin = false;
        },
        CheckLogin() {
            var vm = this;
            companyApi.getMe().then(e => {
                console.log('get,', e)
            });
            return;
            var items = fetch('https://id.magico.pro/api/v1/authorize/me', {
                headers: {
                    "Authorization": "Bearer " + this.$store.state.auth.access_token,
                    'Content-Type': 'application/json; charset=UTF-8'
                    // 'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(resp) {
                if (resp.status == 401) {
                    // vm.isLogin = false;
                    // this.$store.auth.commit('access_expires_in', 0);
                    // vm.refreshToken()
                    alert('refresh token', true)
                }
                // Return the response as JSON
                return resp.json();
            }).then(function(response) {
                console.log(response)
                // vm.authorize()
                //alert('zalogowano')
                // window.location.href = "https://company.magico.pro";
            }).catch(function(err) {
                alert('nie zalogowani');
                // vm.refreshToken()
                console.log('something went wrong', err);
            });;
        },
        refreshToken() {
            var vm = this;
            var refresh_token = this.$store.state.auth.refresh_token
            if (!refresh_token) {
                vm.isLogin = false;
                return;
            }
            if (Math.floor((Date.now() + vm.refresh_time)) < Math.floor(this.$store.state.auth.access_expires_in)) {
                return false;
            }
            fetch('https://id.magico.pro/api/v1/token', {
                method: 'POST',
                body: 'grant_type=refresh_token&client_id=helpdesk&refresh_token=' + refresh_token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(resp) {
                if (resp.status !== 200) {
                    throw new Error(resp.status)
                }
                return resp.json();
            }).then(function(data) {
                if (data.error) {
                    vm.isLogin = false
                    return;
                }
                if (data.access_token) {
                    vm.isLogin = true
                    vm.$store.dispatch('auth/setToken', data);
                }
            }).catch(function(err) {
                console.log('something went wrong', err);
                vm.isLogin = false;
            });;
        },
        getToken() {
            var vm = this;
            var query = new URLSearchParams({
                grant_type: "authorization_code",
                code: vm.oauth_code,
                scope: "openid",
                client_id: "helpdesk",
                redirect_uri: BASE_URL,
            });
            fetch('https://id.magico.pro/api/v1/token', {
                method: 'POST',
                body: query.toString(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(resp) {
                if (resp.status !== 200) {
                    router.push('/')
                    throw new Error(resp.status)
                }
                return resp.json();
            }).then(function(data) {
                if (data.error) {
                    vm.isLogin = false
                    return;
                }
                if (data.access_token) {
                    vm.$store.dispatch('auth/setToken', data);
                    vm.getCompanyMe();
                    window.history.pushState({}, '', '/');
                }
            }).catch(function(err) {
                console.log('something went wrong', err);
                window.location.replace('/')
            });;
        },
        getState: function() {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < 32; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            localStorage.setItem('state', result);
            return result;
        },
        authorize() {
            var query = new URLSearchParams({
                response_type: "code",
                grant_type: "code",
                state: this.getState(),
                scope: "openid",
                client_id: "helpdesk",
                redirect_uri: BASE_URL,
            });
            window.location.href = 'https://id.magico.pro/api/v1/authorize' + '?' + query.toString();;
        }
    },
});